// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleSignInButton({
  className = "",
  label = "Continue with Google",
  testid = "google-signin",
}) {
  const go = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={go}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full border border-slate-300 bg-white font-bold text-slate-800 hover:bg-slate-50 hover:border-slate-400 transition-colors ${className}`}
    >
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
      {label}
    </button>
  );
}
